import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0506 from "../../../lesson/course-05/lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "5c131356-06d8-4111-84f4-72f883cb9077",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
];

export default lessonLinks;
